'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dEdit$002dGrouping$002dPage from "./presto.-Edit-Grouping-Page.js";
var $p;
/** @constructor */
function $c_Lpresto_EditGroupingPage$() {
}
export { $c_Lpresto_EditGroupingPage$ as $c_Lpresto_EditGroupingPage$ };
$p = $c_Lpresto_EditGroupingPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_EditGroupingPage$;
/** @constructor */
function $h_Lpresto_EditGroupingPage$() {
}
export { $h_Lpresto_EditGroupingPage$ as $h_Lpresto_EditGroupingPage$ };
$h_Lpresto_EditGroupingPage$.prototype = $p;
$p.l = (function() {
  return "EditGroupingPage";
});
$p.cG5 = (function(x$0) {
  return new $j_presto$002e$002dEdit$002dGrouping$002dPage.$c_Lpresto_EditGroupingPage($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(0)), x$0.j(1), (!(!x$0.j(2))));
});
var $d_Lpresto_EditGroupingPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_EditGroupingPage$, "presto.EditGroupingPage$", ({
  I1: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_EditGroupingPage$ as $d_Lpresto_EditGroupingPage$ };
var $n_Lpresto_EditGroupingPage$;
function $m_Lpresto_EditGroupingPage$() {
  if ((!$n_Lpresto_EditGroupingPage$)) {
    $n_Lpresto_EditGroupingPage$ = new $c_Lpresto_EditGroupingPage$();
  }
  return $n_Lpresto_EditGroupingPage$;
}
export { $m_Lpresto_EditGroupingPage$ as $m_Lpresto_EditGroupingPage$ };
//# sourceMappingURL=presto.-Edit-Grouping-Page$.js.map
